import { getCookie } from "../mixin/functions";

export type TApiConfiguration = {
    accessToken?: string;
    urlApiBase: string;
    csrfToken?: string;
    feow?: string;
}

export const apiConfigurationDefault = {
    accessToken: getCookie('fec'),
    urlApiBase: location.protocol + '//' + location.host,
    feow: 'reauth_1'
    //csrfToken: document.querySelector('[name=csrf-token]').getAttribute('content')
}